import { fg } from '@confluence/feature-gating';
import { useContentType } from '@confluence/page-context';
import {
	ContentType,
	isCanvasContentType,
} from '@confluence/content-types-utils/entry-points/contentTypeConstants.ts';

export const useIsNewDanglingCommentExperienceEnabled = (): boolean => {
	const [contentType] = useContentType();

	return (
		contentType !== ContentType.DATABASE &&
		!isCanvasContentType(contentType) &&
		fg('confluence_frontend_new_dangling_comments_ux')
	);
};
